export default "__VITE_ASSET__526b5bc9__"